import client from './client';

export interface AnnouncementImage {
  id: string;
  image_url: string;
  original_filename: string | null;
  size_bytes: number | null;
  content_type: string | null;
  created_at: string;
}

export interface Announcement {
  id: number;
  category: string;
  title: string;
  content: string;
  original_author: string | null;
  last_editor: string | null;
  is_active: boolean;
  created_at: string;
  updated_at: string;
  images: AnnouncementImage[];
}

export interface AnnouncementListResponse {
  items: Announcement[];
  total: number;
  page: number;
}

export const getList = async (params: {
  page?: number;
  limit?: number;
  category?: string;
  include_inactive?: boolean;
} = {}): Promise<AnnouncementListResponse> => {
  const res = await client.get('/api/v1/announcements', { params });
  return res.data;
};

export const getById = async (id: number): Promise<Announcement> => {
  const res = await client.get(`/api/v1/announcements/${id}`);
  return res.data;
};

export const create = async (data: {
  title: string;
  content: string;
  category?: string;
}): Promise<Announcement> => {
  const res = await client.post('/api/v1/announcements', data);
  return res.data;
};

export const update = async (
  id: number,
  data: { title?: string; content?: string; category?: string; is_active?: boolean },
): Promise<Announcement> => {
  const res = await client.patch(`/api/v1/announcements/${id}`, data);
  return res.data;
};

export const reactivate = async (id: number): Promise<Announcement> => {
  const res = await client.patch(`/api/v1/announcements/${id}`, { is_active: true });
  return res.data;
};

export const softDelete = async (id: number): Promise<Announcement> => {
  const res = await client.delete(`/api/v1/announcements/${id}`);
  return res.data;
};

export const hardDelete = async (id: number): Promise<{ message: string }> => {
  const res = await client.delete(`/api/v1/announcements/${id}/permanent`);
  return res.data;
};

export const uploadImage = async (
  annId: number,
  file: File,
): Promise<AnnouncementImage> => {
  const form = new FormData();
  form.append('file', file);
  const res = await client.post(`/api/v1/announcements/${annId}/images`, form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return res.data;
};

export const deleteImage = async (imageId: string): Promise<{ message: string }> => {
  const res = await client.delete(`/api/v1/announcements/images/${imageId}`);
  return res.data;
};
